import { BoardModeller } from '../ox-board-modeller.js'
import { chartAndGauge } from './chart-and-gauge.js'
import { container } from './container.js'
import { dataSource } from './data-source.js'
import { etc } from './etc.js'
import { form } from './form.js'
import { iot } from './iot.js'
import { line } from './line.js'
import { shape } from './shape.js'
import { table } from './table.js'
import { textAndMedia } from './text-and-media.js'
import { threed } from './3d.js'
import { warehouse } from './warehouse.js'

export function registerDefaultGroups() {
  BoardModeller.registerGroup(line)
  BoardModeller.registerGroup(shape)
  BoardModeller.registerGroup(textAndMedia)
  BoardModeller.registerGroup(chartAndGauge)
  BoardModeller.registerGroup(table)
  BoardModeller.registerGroup(container)
  BoardModeller.registerGroup(dataSource)
  BoardModeller.registerGroup(iot)
  BoardModeller.registerGroup(threed)
  BoardModeller.registerGroup(warehouse)
  BoardModeller.registerGroup(form)
  BoardModeller.registerGroup(etc)
}
